module.exports = __webpack_public_path__ + "img/xiangpica_sel.2a1c9a91.png";